<template>
	<div class="pa-6">
		<v-card>
			<v-card-title>
				История поиска
				<v-spacer></v-spacer>
			</v-card-title>
			<v-data-table
				v-model="selected"
				:headers="headers"
				:items="data"
				:loading="loadingList"
				:items-per-page="-1"
				hide-default-footer
				show-select
				no-data-text=""
				item-key="id"
			>
				<template v-slot:header.data-table-select></template>
				<template v-slot:item.done="{ item }">
					<span v-if="+item.done">Обработано</span>
					<v-btn v-else small class="tr-hover" color="green" @click.stop="done([item])">
						Обработано
					</v-btn>
				</template>
				<template v-slot:item.time="{ item }">
					{{ item.timeFormatted }}
				</template>
				<template v-slot:item.actions="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on }">
							<v-icon
								small
								v-on="on"
								class="mr-2 tr-hover"
								@click.stop="done([item])">
								undo
							</v-icon>
						</template>
						<span>Не обработано</span>
					</v-tooltip>

					<v-tooltip bottom>
						<template v-slot:activator="{ on }">
							<v-icon
								small
								v-on="on"
								class="mr-2 tr-hover"
								@click.stop="search(item)">
								search
							</v-icon>
						</template>
						<span>Поиск в новом окне</span>
					</v-tooltip>

					<v-tooltip bottom>
						<template v-slot:activator="{ on }">
							<v-icon
								small
								v-on="on"
								class="mr-2 tr-hover"
								@click.stop="count([item])">
								donut_large
							</v-icon>
						</template>
						<span>Подсчет результатов поиска</span>
					</v-tooltip>
				</template>
			</v-data-table>
		</v-card>
		<v-bottom-sheet
			v-model="selected.length"
			inset
			max-width="400"
			hide-overlay
			persistent>
      		<v-card tile dark>
		        <v-list>
		          	<v-list-item>
		            	<v-list-item-content>
		              		<v-list-item-title>Действия с выбранными</v-list-item-title>
		            	</v-list-item-content>


						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-icon
									v-on="on"
									class="mr-2 tr-hover"
									@click="done(selected)">
									done_all
								</v-icon>
							</template>
							<span>Обработано</span>
						</v-tooltip>

						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-icon
									v-on="on"
									class="mr-2 tr-hover"
									@click="done(selected)">
									undo
								</v-icon>
							</template>
							<span>Не обработано</span>
						</v-tooltip>

						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-icon
									v-if="selected.length < 20"
									v-on="on"
									class="mr-2 tr-hover"
									@click="count(selected)">
									donut_large
								</v-icon>
							</template>
							<span>Подсчет результатов поиска</span>
						</v-tooltip>

		          	</v-list-item>
		        </v-list>
	      	</v-card>
	    </v-bottom-sheet>
	</div>
</template>

<style scoped>
	.nowrap {
		white-space: nowrap;
	}
	tr .tr-hover {
		opacity: 0;
	}
	tr:hover .tr-hover {
		opacity: 1;
	}
	tr .tr-not-hover {
		opacity: 1;
	}
	tr:hover .tr-not-hover {
		opacity: 0;
	}
</style>

<script>
	import {api} from '../../lib/api'
	import _ from 'lodash'

	export default {
		data: () => ({
			loadingList: false,
			loadedAll: false,
			data: [],
			selected: [],
			headers: [
				{
					text: 'Поисковый запрос',
					value: 'text',
					align: 'center'
				},
				{
					text: 'Пользователь',
					value: 'userName',
					align: 'center'
				},
				{
					text: 'Дата',
					value: 'time',
					align: 'center'
				},
				{
					text: 'Рез. тогда',
					value: 'results',
					align: 'center'
				},
				{
					text: 'Рез. сегодня',
					value: 'resultsToday',
					align: 'center'
				},
				{
					text: 'Обработано',
					value: 'done',
					align: 'center'
				},
				{
					text: 'Действия',
					value: 'actions',
					align: 'center'
				}
			],
		}),
		created() {
			this.throttledLoadMore = _.throttle(this.loadMore, 1000)
			// this.debouncedLoadMore = _.debounce(this.loadMore, 500)
			this.loadMore()
		},
		mounted() {
			window.onscroll = () => {
				let scrolled = document.documentElement.scrollTop + window.innerHeight > document.documentElement.offsetHeight - 500
				if (scrolled) this.throttledLoadMore()
			}
		},
		methods: {
			done(items) {
				api.post('expenseguide/history_done', {
					ids: items.map(item => item.id)
				})
				.then(response => {
					for (let i in items) {
						items[i].done = 1 - items[i].done
					}
					if (items.length > 1) {
						this.toggleAll()
					}
				}, error => {})
			},
			search(item) {
				window.open('/#/expenses/' + item.text)
			},
			count(items) {
				this.$store.dispatch('dialogLoadingStart')

				api.post('expenseguide/history_count', {
					searches: items.map(item => item.text)
				})
				.then(response => {

					for (let i in items) {
						let resultsToday = response.data.results[i]

						let diff = resultsToday - items[i].results
						if (diff > 0) resultsToday += ' (+' + diff + ')'
						else if (diff < 0) resultsToday += ' (' + diff + ')'

						this.$set(items[i], 'resultsToday', resultsToday)

						this.$store.dispatch('dialogLoadingStop')
					}

				}, error => {})
			},
			loadMore() {
				if (!this.loadedAll && !this.loadingList) {
					this.loadingList = true

					api.post('expenseguide/get_history', {
						offset: this.data.length
					})
					.then(response => {
						// console.log('loadMore Response', response.data.data[0].id, response.data.data[response.data.data.length - 1].id)

						response.data.data.forEach(r => this.data.push(r))
						this.loadedAll = response.data.all
						this.loadingList = false

					}, error => {})
				}
			},
			toggleAll () {
				this.selected = []
			},
		}
	}
</script>
